import { ChevronRightIcon as HeroChevronRightIcon } from '@heroicons/react/24/outline';
export const ChevronRightIcon = HeroChevronRightIcon;
